import { createFeature, createReducer, on } from '@ngrx/store'
import { caseActions } from './case.actions'
import { CaseState } from './case.state'

const createInitialState = (): CaseState => ({
    caseId: null,
    caseName: null,
    isSharedCase: false,
    caseMarkers: [],
    caseSegObjectPropertyMap: undefined,
    caseSegObjectPropertyMaps: [],
    caseRcnResults: [],
    caseNeighborhoodEnrichmentResults: [],
    caseTsneResults: [],
    caseUmapResults: [],
    caseCellTypeDetectionResults: [],
    casePlottingResults: [],
})

export const caseFeature = createFeature({
    name: 'case',
    reducer: createReducer<CaseState>(
        createInitialState(),
        on(caseActions.loadCase, (state, { caseId, caseName, shared }): CaseState => {
            return {
                ...state,
                caseId: caseId,
                caseName: caseName,
                isSharedCase: shared,
                caseMarkers: [],
                caseSegObjectPropertyMap: undefined,
                caseSegObjectPropertyMaps: [],
                caseRcnResults: [],
                caseNeighborhoodEnrichmentResults: [],
                caseTsneResults: [],
                caseUmapResults: [],
                caseCellTypeDetectionResults: [],
                casePlottingResults: [],
            }
        }),

        on(caseActions.loadingSegObjectPropertiesDataSucceeded, (state, action): CaseState => {
            return {
                ...state,
                caseMarkers: action.segobjectpropertiesdata,
            }
        }),

        on(caseActions.loadingSegObjectPropertyMapsSucceeded, (state, action): CaseState => {
            return {
                ...state,
                caseSegObjectPropertyMaps: action.segobjectpropertymaps,
            }
        }),
        on(
            caseActions.loadingRecurrentNeighborhoodsResultsSucceeded,
            (state, { neighborhood }): CaseState => {
                return {
                    ...state,
                    caseRcnResults: neighborhood,
                }
            }
        ),
        on(
            caseActions.loadingNeighborhoodEnrichmentResultsSucceeded,
            (state, { neighborhood }): CaseState => {
                return {
                    ...state,
                    caseNeighborhoodEnrichmentResults: neighborhood,
                }
            }
        ),
        on(caseActions.loadingTsneResultsSucceeded, (state, { tsne }): CaseState => {
            return {
                ...state,
                caseTsneResults: tsne,
            }
        }),
        on(caseActions.loadingUmapResultsSucceeded, (state, { umap }): CaseState => {
            return {
                ...state,
                caseUmapResults: umap,
            }
        }),
        on(
            caseActions.loadingAutoCellDetectionResultsSucceeded,
            (state, { autoCellDetection }): CaseState => {
                return {
                    ...state,
                    caseCellTypeDetectionResults: autoCellDetection,
                }
            }
        ),
        on(caseActions.loadingPlottingResultsSucceeded, (state, { plotting }): CaseState => {
            return {
                ...state,
                casePlottingResults: plotting,
            }
        }),

        on(caseActions.loadSegObjectPropertiesData, (state, action): CaseState => {
            return {
                ...state,
                caseSegObjectPropertyMap: action.segobjectpropertymap,
            }
        })
    ),
})

export const { reducer } = caseFeature
